import { IView } from 'src/store/type-displayed-spinner/types';
import { EFloorType } from 'src/store/view-2d/reducer';
import { ISubViewMappingEFloorType } from 'src/typings/table';

export const getEnabledCrosstableFloorTypes = (views: IView[]): EFloorType[] => {
  const crosstableView = views.find((view) => view.type === 'Crosstable' && view.isEnabled);

  return [...(crosstableView?.subViews || [])]
    .filter((subView) => subView.isEnabled)
    .sort((first, second) => first.sortOrder - second.sortOrder)
    .map((subView) => ISubViewMappingEFloorType[subView.type])
    .filter((floorType): floorType is EFloorType => Boolean(floorType));
};

export const resolveCrosstableFloorType = (views: IView[]): EFloorType | undefined => {
  const enabledFloorTypes = getEnabledCrosstableFloorTypes(views);

  return enabledFloorTypes[0];
};
